import ModelEntity from "../model-entity";
import FieldProto from "../../fields3/proto/field-proto";
import Task from "../task/task";
import {EntityType} from "../../gd/const/item";
import Collection from "../../data-structures/collection";


export default class EntityCollection extends Collection<ModelEntity> {

    public models       : ModelEntity[]           = []
    protected byRid     : {[key:RID]:ModelEntity}  = {}

    // not in use just to be compatible with Collection TS
    protected byId  : {[key:ID]:ModelEntity}  = {}

    constructor(models: ModelEntity[] = []) {
        super(models)
        // if (models) {
        //     this.reset(models)
        // }
    }


    // Init Methods

    addTasksFromJson(tasksData: JSONArray):void {
        _.map(tasksData, (taskData:any)=>{
            this.add(new Task(taskData))
        })
    }

    // End init

    //

    get allTasks():Task[] {
        return _.filter(this.models, (entity:ModelEntity)=>{
            return entity.itemType === EntityType.TASK
        }) as Task[]
    }

    //

    addAtPosition(model:ModelEntity, postion:number) {
        this.models.splice(postion, 0, model)
        this.byRid[model.rid] = model
    }


    // old used in gd.sessionCustomViews ?
    get all() {
        return this.models
    }

    // used in GLIST
    get items() {
        return this.models
    }

    get isEmpty() {
        return !this.models || this.models.length < 1
    }

    get length() {
        return this.models ? this.models.length : 0
    }

    get ids() {
        return _.keys(this.byRid)
    }

    reset(models?:ModelEntity[]) {
        this.models    = []
        this.byRid     = {}

        _.map(models, model=>{
            this.add(model)
        })
    }

    add(model:ModelEntity) {

        if (!model) {
            console.warn("Try to add empty model #djdhs999sa")
            return
        }


        // vozmozno eto horosho i dolzno bit' tut - a vozmono net... hez :) poka mi tak delaem tol'ko v ItemsCollection
        // const existingModel = this.byId[model.id]
        // if (existingModel) {
        //     console.log("#8474uu Collection Model", model.id, "already existis -> Skip")
        //     return
        // }

        this.models.push(model)
        this.byRid[model.rid] = model
    }

    // addAtPosition(model:Model, postion:number) {
    //     this.models.splice(postion, 0, model)
    //     this.byId[model.id] = model
    // }

    removeModel(model:ModelEntity) {
        const rid = model.rid

        delete this.byRid[rid]
        return _.remove(this.models, (iteratedModel)=> iteratedModel.rid === rid)
    }

    remove(rid:RID) {

        const model = this.get(rid)
        if (model) {
            return this.removeModel(model)
        } else {
            return []
        }
    }

    // remove(model:ModelEntity) {
    //     const rid = model.rid
    //
    //     delete this.byRid[rid]
    //     return _.remove(this.models, (iteratedModel)=> iteratedModel.rid === rid)
    // }

    replace(rid: RID, model:ModelEntity) {
        // find index of model to replace
        const index = _.findIndex(this.models, model=>model.rid === rid)

        // replace model at index
        this.models.splice(index, 1, model)

        delete this.byRid[rid]        // remove old model
        this.byRid[model.rid] = model // add new model
    }

    get(rid: RID):ModelEntity | null {
        return this.byRid[rid]
    }



    // used when we want to store sort position within collection itself
    // i.e. manual sorting without sortPosition field
    reorderByIds(orderedIds: RID[]):void {
        const result:any[] = []
        _.map(orderedIds, id=>{
            result.push(this.get(id))
        })
        this.models = result
    }

    toJSON():any {
        return _.map(this.models, model=>model.toJSON())
    }

    exportToCSV(arrayOfFields:FieldProto[], arrayOfIds:fieldId[]) {
        throw Error("Not implemented #kdjs3233i")
    }


}